<template>
  <div class="footerSection py-2 ps-3 bg-light text-start">
    <p class="mb-0 fs-6">&copy; Copyright <strong><span>Ubibat</span></strong>. All Rights Reserved. 2024
      <font-awesome-icon icon="fa-solid fa-user-secret" />
    </p>
    <!-- <p class="p-0 m-0 ">Powered by <a class="text-decoration-underline text-black" href="https://yassin-kchaou-portfolio.netlify.app/"> Yassine kchaou </a></p> -->
  </div>
</template>